import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";
import Table from "@components/Table";
import ModalConfirmation from "@components/ModalConfirmation";
import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import Title from "@components/Title";
import { useTranslation } from "react-i18next";
import useListColumns from "@hooks/Security/Users/useListColumns";
import deleteUser from "@services/Core/Users/deleteUser";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import { EUiStates } from "@constants/enum";
import useListItems from "@hooks/Shared/useListItems";
import getUsers from "@services/Core/Users/getUsers";
import listUserMapper from "@mappers/Security/Users/ListUser.mapper";

const ListUsers = (): ReactElement => {
  const { t } = useTranslation(["core"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getUsers,
    listUserMapper,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("core:users.users")} | ${t("core:common.delete_confirm")}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.description
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteUser);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListUsers;
